<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12 mb-4 d-flex justify-content-between">
      <button routerLink="/backoffice/management/users" [queryParams]="{ isBack: true }" class="btn btn-sm btn-primary"><i class="fa fa-chevron-left"></i> Back</button>
      <div class="d-flex gap-2">
        @if (user.isBanned) {
          <button class="btn btn-sm btn-success" type="button" (click)="onClickUnbanUser()"><i class="fa fa-unlock"></i> Unban User</button>
        } @else {
          <button class="btn btn-sm btn-warning" type="button" (click)="onClickBanUser()"><i class="fa fa-ban"></i> Ban User</button>
        }
        @if (user.isDeleted || user.deleteDateTimestamp > 0) {
          <button class="btn btn-sm btn-success" type="button" (click)="onClickRestoreUser()"><i class="fa fa-undo"></i> Restore User</button>
        } @else {
          <button class="btn btn-sm btn-danger" type="button" (click)="onClickDeleteUser()"><i class="fa fa-trash"></i> Delete User</button>
        }
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 mb-4">
      <tabset #userTabs>
        <!-- DETAILS TAB -->
        <tab heading="Details" (selectTab)="onSelectTabDetails($event)">
          <div class="row">
            <div class="col-md-12 mb-4">
              <!-- <button (click)="openUserEditModal()" class="btn btn-sm btn-primary" >Modifier</button> -->
              <!-- <br/><br/> -->
              <!-- <button [hidden]="user.isBanned == false" class="btn btn-sm btn-primary" type="button" (click)="onClickUnbanButton()">Débannir l'utilisateur</button>
              <button [hidden]="user.isBanned == true" class="btn btn-sm btn-danger" type="button" (click)="onClickBanButton()">Bannir l'utilisateur</button> -->
              <!-- <br/> -->
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <dl class="dl-horizontal">
                <dt>ID</dt>
                <dd>{{ user.userId }}</dd>
                <dt>nickname</dt>
                <dd>
                  {{ user.firstname || 'Guest' + user.userId }}
                  @if (user.firstname) {
                    <button class="btn btn-sm btn-primary ms-2" (click)="openEditNicknameModal()"><i class="fa fa-edit"></i></button>
                  }
                </dd>
                <dt>Account type</dt>
                <dd>{{ UserAccountType[user.accountType] }}</dd>
                <dt>Email</dt>
                <dd>{{ user.email }}</dd>
                <dt>Created at</dt>
                <dd>{{ dateService.getDateFromatted(user.createdAtTimestamp) }}</dd>
                <dt>Language</dt>
                <dd>{{ user.locale }}</dd>
                <dt>Last login</dt>
                <dd>
                  @if (user.session) {
                    <div class="d-flex gap-4">
                      <div>
                        <div class="text-muted small">Time</div>
                        {{ dateService.getDateFromatted(user.session.createTimeTimestamp) }}
                      </div>
                      <div>
                        <div class="text-muted small">IP</div>
                        {{ user.session.ipAddress }}
                      </div>
                      <div>
                        <div class="text-muted small">Version</div>
                        {{ user.session.appVersion }}
                      </div>
                    </div>
                  } @else {
                    <span class="text-muted">No session</span>
                  }
                </dd>
                <dt>Bought Credit</dt>
                <dd>{{ user.shopBuyCredits }}</dd>
                @if (user.deleteDateTimestamp) {
                  <dt>Delete started at</dt>
                  <dd>{{ dateService.getDateFromatted(user.deleteDateTimestamp) }}</dd>
                }
                <dt>Status</dt>
                <dd>
                  @if (user.isOnline()) {
                    <span class="badge bg-success">Online</span>
                  }
                  @if (user.isBanned) {
                    <span class="badge bg-danger">Banned</span>
                  }
                  @if (user.isDeleted) {
                    <span class="badge bg-danger">Deleted</span>
                  } @else if (user.deleteDateTimestamp > 0) {
                    <span class="badge bg-warning">Delete in progress</span>
                  }
                </dd>
              </dl>
            </div>
          </div>

          <!-- USER Currency -->
          <div class="row">
            <div class="col-lg-12">
              <div class="card" >
                <div class="card-header" (click)="isUserDetailsCurrencyOpen = !isUserDetailsCurrencyOpen" style="cursor:pointer">
                  <i class="fa fa-globe"></i> Currencies
                  <div class="pull-right">
                    @if (isUserDetailsCurrencyOpen) {
                      <i class="fa fa-chevron-down"></i>
                    } @else {
                      <i class="fa fa-chevron-left"></i>
                    }
                  </div>
                </div>
                <div class="card-body" [collapse]="!isUserDetailsCurrencyOpen">
                  <div class="row mb-2">
                    <div class="col-lg-12">
                      <button (click)="openUserUpdateCurrencyModal()" class="btn btn-sm btn-primary">
                        <i class="fa fa-plus"></i> Add currency
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <dl class="dl-horizontal">
                        @for (currency of user.currencies; track $index) {
                          <dt>{{ UserCurrencyType[currency.currencyType] }}</dt>
                          <dd>
                            {{ currency.currencyQuantity }}
                            @if (currency.currencyTicketCost > 0) {
                              <span class="text-muted ms-1">(ticket cost: {{ currency.currencyTicketCost }})</span>
                            }
                          </dd>
                        }
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- USER Level -->
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-header" (click)="isUserDetailsLevelOpen = !isUserDetailsLevelOpen" style="cursor:pointer">
                  <i class="fa fa-star"></i> Level
                  <div class="pull-right">
                    @if (isUserDetailsLevelOpen) {
                      <i class="fa fa-chevron-down"></i>
                    } @else {
                      <i class="fa fa-chevron-left"></i>
                    }
                  </div>
                </div>
                <div class="card-body" [collapse]="!isUserDetailsLevelOpen">
                  <div class="row mb-2">
                    <div class="col-lg-12">
                      <button (click)="openAddExperienceModal()" class="btn btn-sm btn-primary">
                        <i class="fa fa-plus"></i> Add Experience
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <dl class="dl-horizontal">
                        <dt>Level</dt>
                        <dd>{{ user.experienceLevel }}</dd>
                        <dt>Experience</dt>
                        <dd>{{ user.experiencePoint }}</dd>
                        <dt>Next level</dt>
                        <dd>{{ user.experienceNextLevelPoint }}</dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- USER Boosters -->
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-header" (click)="isUserDetailsBoostersOpen = !isUserDetailsBoostersOpen" style="cursor:pointer">
                  <i class="fa fa-bolt"></i> Boosters
                  <div class="pull-right">
                    @if (isUserDetailsBoostersOpen) {
                      <i class="fa fa-chevron-down"></i>
                    } @else {
                      <i class="fa fa-chevron-left"></i>
                    }
                  </div>
                </div>
                <div class="card-body" [collapse]="!isUserDetailsBoostersOpen">
                  <div class="row mb-2">
                    <div class="col-lg-12">
                      <button (click)="openAddBoosterModal()" class="btn btn-sm btn-primary">
                        <i class="fa fa-plus"></i> Add Booster
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <dl class="dl-horizontal">
                        @for (booster of user.boosters; track $index) {
                          <dt>{{ UserBoosterType[booster.type] }} (x{{ booster.multiplier }})</dt>
                          <dd>time remaining : {{ booster.duration }}s</dd>
                        }
                        @if (user.boosters.length === 0) {
                          <dd class="text-muted">No boosters</dd>
                        }
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- USER Statistics -->
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-header" (click)="isUserDetailsStatisticsOpen = !isUserDetailsStatisticsOpen" style="cursor:pointer">
                  <i class="fa fa-bar-chart"></i> Statistics
                  <div class="pull-right">
                    @if (isUserDetailsStatisticsOpen) {
                      <i class="fa fa-chevron-down"></i>
                    } @else {
                      <i class="fa fa-chevron-left"></i>
                    }
                  </div>
                </div>
                <div class="card-body" [collapse]="!isUserDetailsStatisticsOpen">
                  <div class="row">
                    <div class="col-lg-12">
                      <dl class="dl-horizontal">
                        <dt>Games</dt>
                        <dd>{{ user.statistics.game }}</dd>
                        <dt>Wins</dt>
                        <dd>{{ user.statistics.win }}</dd>
                      </dl>
                    </div>
                  </div>
                  <div class="d-flex gap-5 mt-2">
                    <div>
                      <small class="text-muted d-block fw-semibold mb-1">Slot</small>
                      <div class="d-flex gap-3">
                        <div>
                          <small class="text-muted">Reward</small>
                          <div class="fw-bold text-success">{{ user.statistics.slotReward }}</div>
                        </div>
                        <div>
                          <small class="text-muted">Cost</small>
                          <div class="fw-bold text-danger">{{ user.statistics.slotCost }}</div>
                        </div>
                        <div>
                          <small class="text-muted">Balance</small>
                          <div class="fw-bold" [class.text-success]="user.statistics.slotReward - user.statistics.slotCost >= 0" [class.text-danger]="user.statistics.slotReward - user.statistics.slotCost < 0">
                            {{ user.statistics.slotReward - user.statistics.slotCost }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <small class="text-muted d-block fw-semibold mb-1">Game</small>
                      <div class="d-flex gap-3">
                        <div>
                          <small class="text-muted">Reward</small>
                          <div class="fw-bold text-success">{{ user.statistics.gameReward }}</div>
                        </div>
                        <div>
                          <small class="text-muted">Cost</small>
                          <div class="fw-bold text-danger">{{ user.statistics.gameCost }}</div>
                        </div>
                        <div>
                          <small class="text-muted">Balance</small>
                          <div class="fw-bold" [class.text-success]="user.statistics.gameReward - user.statistics.gameCost >= 0" [class.text-danger]="user.statistics.gameReward - user.statistics.gameCost < 0">
                            {{ user.statistics.gameReward - user.statistics.gameCost }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab>

        <!-- SESSIONS TAB -->
        <tab heading="Sessions" (selectTab)="onSelectTabSessions()">
          <app-user-sessions-tab #sessionsTab [userId]="userId"></app-user-sessions-tab>
        </tab>

        <!-- TRANSACTIONS TAB -->
        <tab heading="Transactions" (selectTab)="onSelectTabTransactions()">
          <app-user-transactions-tab #transactionTab [userId]="userId"></app-user-transactions-tab>
        </tab>

        <!-- MATCHS TAB -->
        <tab heading="Matchs" (selectTab)="onSelectTabMatchs()">
          <app-user-matchs-tab #matchTab [userId]="userId"></app-user-matchs-tab>
        </tab>
        
        <!-- LEAGUES TAB -->
        <tab heading="Leagues" (selectTab)="onSelectTabLeagues()">
          <app-user-leagues-tab #leaguesTab [userId]="userId"></app-user-leagues-tab>
        </tab>
        
        <!-- TOURNAMENTS TAB -->
        <tab heading="Tournaments" (selectTab)="onSelectTabTournaments()">
          <app-user-tournaments-tab #tournamentsTab [userId]="userId"></app-user-tournaments-tab>
        </tab>

        <!-- COLLECTIONS TAB -->
        <tab heading="Collections" (selectTab)="onSelectTabCollections()">
          <app-user-collections-tab #collectionsTab [userId]="userId"></app-user-collections-tab>
        </tab>

        <!-- LOGS TAB -->
        <tab heading="Logs" (selectTab)="onSelectTabLogs()">
          <app-user-logs-tab #logsTab [userId]="userId"></app-user-logs-tab>
        </tab>

        <!-- MESSAGES TAB -->
        <tab heading="Messages" (selectTab)="onSelectTabMessages()">
          <app-user-messages-tab #messagesTab [userId]="userId" [userLocale]="user.locale"></app-user-messages-tab>
        </tab>

        <!-- REPORTS TAB -->
        <tab heading="Reports" (selectTab)="onSelectTabReports()">
          <app-user-reports-tab #reportsTab [userId]="userId" [userLocale]="user.locale"></app-user-reports-tab>
        </tab>

      </tabset>
    </div>
  </div>
</div>

<!-- Edit nickname modal -->
<div bsModal #editNicknameModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Edit Nickname</h4>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Nickname</label>
          <input class="form-control" [(ngModel)]="editedNickname" type="text" placeholder="Nickname">
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isUserEditLoading" type="button" class="btn btn-secondary" (click)="editNicknameModal.hide()">Cancel</button>
        <button [disabled]="isUserEditLoading" type="button" class="btn btn-primary" (click)="saveEditNickname()">
          <span *ngIf="isUserEditLoading" class="spinner-border spinner-border-sm mr-1"></span>
          Save
        </button>
      </div>
    </div>
  </div>
</div>

<app-user-add-experience-modal #addExperienceModal [userId]="userId"></app-user-add-experience-modal>
<app-user-add-currency-modal #addCurrencyModal [userId]="userId"></app-user-add-currency-modal>
<app-user-add-booster-modal #addBoosterModal [userId]="userId"></app-user-add-booster-modal>